package com.rdapps.weddinginvitation.model

enum class SourcePlatform {
    Android,
    Web
}